import { createFileRoute } from '@tanstack/react-router'

import { NumberEventsPage } from '#/modules/communication/number-events-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/number-events')({
  component: NumberEventsPage,
  validateSearch: validateListSearch,
})
